/*
We need this functionality straight inside the editor,
but it has a lot if redundancy for the frontend, so by checking if the rootContainer exists we determine
whether are we in editor or on the frontend.

Firstly we add listeners for existing items, and then we add observer to look for newly added items

We add some timeout to make sure that the elements are loaded before we start adding listeners
 */
( () => {
    document.addEventListener( 'DOMContentLoaded', () => {
        setTimeout( () => {
            const rootContainer = document.querySelector( '.is-root-container' );
            if ( rootContainer ) {
                function onDetailsClick( e, details ) {
                    if ( e.target.classList.contains( 'splitkon-elements-item__close-popup-button' ) ) {
                        e.preventDefault();
                        details.open = false;
                    }
                }

                const callback = ( mutationList, observer ) => {
                    for ( const mutation of mutationList ) {
                        mutation.addedNodes?.forEach( ( added_node ) => {
                            if ( added_node.classList?.contains( 'splitkon-elements-item' ) ) {
                                const details = added_node.querySelector( ':scope .splitkon-elements-item__details' );
                                details.addEventListener( 'click', ( e ) => {
                                    onDetailsClick( e, details )
                                } );
                            }
                        } );
                    }
                };

                document.querySelectorAll( '.splitkon-elements-item__details' )?.forEach( ( details ) => {
                    details.addEventListener( 'click', ( e ) => {
                        onDetailsClick( e, details )
                    } );
                } );

                const observer = new MutationObserver( callback );
                observer.observe( rootContainer, {childList: true, subtree: true} );
            }
        }, 2000 );
    } )
} )();
